import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Redirector from 'react-redirector';
import projectsUrl from './constants';
//import ReactGA from 'react-ga';
//ReactGA.initialize('UA-218924087-2');
//ReactGA.pageview(window.location.pathname + window.location.search);

class ProjectsRedirector extends Component {
  renderProject = () => {
    const { pathname: project } = window.location;
    return <Redirector to={`${projectsUrl}${project}`} />;
  };

  render() {
    return (
      <Router>
        <Switch>
          <Route component={this.renderProject} />
        </Switch>
      </Router>
    );
  }
}

ReactDOM.render(<ProjectsRedirector />, document.getElementById('redirect'));
